import { URL_BASE_PHP_7, URL_BASE_PHP_8 } from 'constants/urls';

export const URLS_PAGO = {
  catalogoPantalla: `${URL_BASE_PHP_7}api/v1/pago/catalogo-pantalla`,
  mediosPago: `${URL_BASE_PHP_7}api/v1/pago/listar-medios-pago`,
};
